import ImportEmployeesRequestModelBase from '../_generated/modelBases/import-employees-request-model-base';

export default class ImportEmployeesRequestModel extends ImportEmployeesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
